import { Component, ViewContainerRef } from '@angular/core';
import { NotificationEventService } from '../../services/event/notification-event.service';
import { NotificationEvent } from '../../models/events/notification-event.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-create-notification-event',
    templateUrl: './create-notification-event.component.html',
    styleUrls: ['./create-notification-event.component.css']
})
/** create-notification-event component*/
export class CreateNotificationEventComponent {
  public notificationEvent = new NotificationEvent();
    /** create-notification-event ctor */
  constructor(private readonly notificationEventService: NotificationEventService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.rolePermissionService.GetRolePermissions("notificationevent").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {


            this.toastr.setRootViewContainerRef(vcr);
            this.notificationEvent.isActive = true;
          }
          else {
            this.router.navigate(["/notification-event-list"]);
          }
        }
        else {
          this.router.navigate(["/notification-event-list"]);
        }
      }
    )
  }
  onSubmit() {
    this.toastr.success('Event Notification saved successfully.', 'Success');
    this.notificationEventService.AddNotificationEvent(this.notificationEvent);
  }
}



// WEBPACK FOOTER //
// ./src/app/event-components/create-notification-event/create-notification-event.component.ts